export default {
  methods: {
    dateToString(date) {
      return new Date(date).toLocaleDateString();
    },
    dateTimeToString(date) {
      return new Date(date).toLocaleString();
    },
    durationToString(seconds) {
      if (seconds < 100) {
        return `${seconds.toFixed(0)}秒`;
      } else if (seconds < 6000) {
        return `${Math.floor(seconds / 60)}分${(seconds % 60).toFixed(0)}秒`;
      } else if (seconds < 172800) {
        return `${Math.floor(seconds / 3600)}时${(seconds % 3600 / 60).toFixed(0)}分`;
      } else {
        return `${Math.floor(seconds / 86400)}天${(seconds % 86400 / 3600).toFixed(0)}时`
      }
    }
  },
};
